var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockpick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.565,
    height: 15.508,
    viewBox: "0 0 13.565 15.508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Unione_23",
    "data-name": "Unione 23",
    d: "M-300.257,22568.506a1.745,1.745,0,0,1-1.745-1.744v-5.041a1.744,1.744,0,0,1,1.745-1.738h.64v-2.582a4.406,4.406,0,0,1,4.4-4.4,4.409,4.409,0,0,1,4.4,4.4v2.582h.64a1.742,1.742,0,0,1,1.739,1.738v5.041a1.744,1.744,0,0,1-1.739,1.744Zm7.839-8.523v-2.582a2.8,2.8,0,0,0-2.8-2.8,2.806,2.806,0,0,0-2.8,2.8v2.582Z",
    transform: "translate(302.002 -22552.998)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockpick);
export default __webpack_public_path__ + "static/media/lockpick.d6c16ee46f740f13f8f2a3273d60cedd.svg";
export { ForwardRef as ReactComponent };